import { useEffect, useState } from 'react'

const COMPACT_BREAKPOINT = 1440
const WIDE_BREAKPOINT = 2560

const getMode = () => {
  if (typeof window === 'undefined') {
    return { isCompact: false, isWide: false }
  }
  const width = window.innerWidth
  return {
    isCompact: width < COMPACT_BREAKPOINT,
    isWide: width >= WIDE_BREAKPOINT,
  }
}

export const useViewportMode = () => {
  const [mode, setMode] = useState(getMode)

  useEffect(() => {
    const handleResize = () => setMode(getMode())
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return mode
}

export const useIsCompact = () => useViewportMode().isCompact
